import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'
import { Navigate } from 'react-router'

const RedirectToRightsholderSummary = () => {
    const { rightsholderStore } = useContext(StoresContext)
    return <Navigate to={Navigation.rightholder.summary(rightsholderStore.currentRightsholderId)} replace />
}

export default RedirectToRightsholderSummary
